export { default } from './commit-lint.js';
